import { BookOutlined } from '@mui/icons-material'
import {
	IconAdjustmentsCheck,
	IconActivity,
	IconArticle,
	IconPhoto,
	IconBellFilled,
	IconBrandIntercom,
	IconCalendarEventFilled,
	IconCategoryFilled,
	IconDatabaseCog,
	IconFileSettings,
	IconBrandGoogleAnalytics,
	IconNetwork,
	IconOutbound,
	IconPlayerPlay,
	IconReportAnalytics,
	IconSectionFilled,
	IconSettings,
	IconMessageCircle,
	IconSchool,
	IconSticker,
} from '@tabler/icons-react'
import { FaChartPie, FaHouseUser } from 'react-icons/fa'
import { FaChartColumn } from 'react-icons/fa6'
import { pathUrl } from 'src/variable/constant'

const style = { height: 20, width: 20 }
interface NavItem {
	name: string
	icon: React.ReactNode
	to?: string
	action?: 'logout'
	permission?: string
	role?: string
	children?: NavItem[]
}
const nav: NavItem[] = [
	{
		name: 'Dashboard',
		to: pathUrl.home,
		permission: 'HOME:DASHBOARD',
		icon: <FaChartPie style={{ ...style }} />,
	},
	// {
	// 	name: 'Home',
	// 	permission: 'HOME',
	// 	icon: <FaChartColumn style={{ ...style }} />,
	// 	children: [
	// 		{
	// 			name: 'User of Province',
	// 			to: pathUrl.province,
	// 			permission: 'HOME:USER_OF_PROVINCE',
	// 			icon: <IconUsers style={{ ...style }} />,
	// 		},
	// 		{
	// 			name: 'User by Countries',
	// 			to: pathUrl.country,
	// 			permission: 'HOME:USER_OF_COUNTRY',
	// 			icon: <FaMapLocationDot style={{ ...style }} />,
	// 		},
	// 	],
	// },
	{
		name: 'User',
		permission: 'ACCOUNT',
		to: '/users',
		icon: <FaHouseUser style={{ ...style }} />,
		// children: [
		// 	{
		// 		name: 'Guider',
		// 		to: '/guiders',
		// 		permission: 'ACCOUNT:GUIDER',
		// 		icon: <FaPeopleGroup style={{ ...style }} />,
		// 	},
		// 	{
		// 		name: 'User',
		// 		to: '/users',
		// 		permission: 'ACCOUNT:USER',
		// 		icon: <FaPerson style={{ ...style }} />,
		// 	},
		// 	{
		// 		name: 'Employee',
		// 		to: '/employees',
		// 		role: 'SUPERADMIN',
		// 		permission: 'ACCOUNT:EMPLOYEE',
		// 		icon: <FaUserGroup style={{ ...style }} />,
		// 	},
		// 	// {
		// 	// 	name: 'Role',
		// 	// 	to: '/roles',
		// 	// 	// permission: 'ACCOUNT:ROLE',
		// 	// 	icon: <IconSectionFilled style={{ ...style }} />,
		// 	// }
		// ],
	},
	{
		name: 'Active Users',
		permission: 'ACCOUNT',
		to: pathUrl.activeUsers,
		icon: <IconActivity style={{ ...style }} />,
	},
	{
		name: 'Redeem requests',
		to: pathUrl.redeemRequests,
		icon: <IconSectionFilled style={{ ...style }} />,
	},
	{
		name: 'Events',
		permission: 'EVENTS',
		icon: <IconCalendarEventFilled style={{ ...style }} />,
		to: pathUrl.event,
	},
	// {
	// 	name: 'Services',
	// 	permission: 'SERVICES',
	// 	icon: <IconSectionFilled style={{ ...style }} />,
	// 	to: pathUrl.service,
	// },
	{
		name: 'Communities',
		permission: 'COMMUNITIES',
		icon: <IconNetwork style={{ ...style }} />,
		to: pathUrl.network,
		// children: [
		// 	{
		// 		name: "List",
		// 		permission: 'COMMUNITIES',
		// 		icon: <IconNetwork style={{ ...style }} />,
		// 		// icon: <IconContract style={{ ...style }} />,
		// 		to: pathUrl.network,
		// 	},
		// 	{
		// 		name: "Category",
		// 		permission: 'CATEGORY:NETWORKS_NAME',
		// 		icon: <IconContract style={{ ...style }} />,
		// 		to: pathUrl.conversation,
		// 	},
		// ]
	},
	{
		name: 'Topic discuss',
		permission: 'CATEGORY:TOPIC_DISCUSS',
		icon: <IconArticle style={{ ...style }} />,
		to: pathUrl.topics,
	},
	{
		name: 'Book',
		permission: 'LIBRARY',
		icon: <BookOutlined style={{ ...style }} />,
		to: pathUrl.book,
		// children: [
		// 	{
		// 		name: 'Book Normal',
		// 		permission: 'LIBRARY',
		// 		icon: <BookOutlined style={{ ...style }} />,
		// 		to: pathUrl.book,
		// 	},
		// 	{
		// 		name: 'Book UniVini',
		// 		permission: 'LIBRARY',
		// 		icon: <BookOutlined style={{ ...style }} />,
		// 		to: pathUrl.bookUniVini,
		// 	},
		// ]
	},
	{
		name: 'Find My Tutor',
		role: 'SUPERADMIN',
		icon: <IconArticle style={{ ...style }} />,
		to: pathUrl.findMyTutor,
	},
	{
		name: 'Course AI',
		role: 'SUPERADMIN',
		icon: <IconSchool style={{ ...style }} />,
		to: pathUrl.courseAi,
	},
	{
		name: 'List Your Biz',
		role: 'SUPERADMIN',
		icon: <IconSectionFilled style={{ ...style }} />,
		to: pathUrl.listYourBiz,
	},
	{
		name: 'Find My Guide',
		role: 'SUPERADMIN',
		icon: <IconNetwork style={{ ...style }} />,
		to: pathUrl.findMyGuide,
	},
	{
		name: 'Trails Collections',
		permission: 'CATEGORY:TRAILS',
		// permission: 'CATEGORY',
		icon: <IconCategoryFilled style={{ ...style }} />,
		// icon: <IconLayersSelected style={{ ...style }} />,
		to: '/categorytrails',
		// children: [
		// 	{
		// 		name: 'Trails',
		// 		permission: 'CATEGORY:TRAILS',
		// 		icon: <IconCategoryFilled style={{ ...style }} />,
		// 		to: '/categorytrails',
		// 	},
		// ],
	},
	{
		name: 'Sticker',
		role: 'SUPERADMIN',
		icon: <IconSticker style={{ ...style }} />,
		to: pathUrl.sticker,
	},
	{
		name: 'Banner',
		role: 'SUPERADMIN',
		icon: <IconPhoto style={{ ...style }} />,
		to: pathUrl.banner,
	},
	{
		name: 'Alert',
		permission: 'NOTIFICATION',
		icon: <IconBellFilled style={{ ...style }} />,
		to: pathUrl.notification,
		children: [
			{
				name: 'Notification',
				permission: 'NOTIFICATION',
				icon: <IconBellFilled style={{ ...style }} />,
				to: pathUrl.notification,
			},
			{
				name: 'Support Inbox',
				permission: 'NOTIFICATION',
				icon: <IconMessageCircle style={{ ...style }} />,
				to: pathUrl.supportInbox,
			},
			{
				name: 'New Version',
				role: 'SUPERADMIN',
				icon: <IconSectionFilled style={{ ...style }} />,
				to: pathUrl.changelog,
			},
		]
	},
	{
		name: 'Settings',
		permission: 'SETTINGS',
		icon: <IconSettings style={{ ...style }} />,
		to: '/settings',
	},
	{
		name: 'Report',
		permission: 'REPORT',
		icon: <IconReportAnalytics style={{ ...style }} />,
		to: pathUrl.report,
	},
	{
		name: 'Badword',
		permission: 'BAD_WORD',
		icon: <IconArticle style={{ ...style }} />,
		to: pathUrl.badword,
	},
	{
		name: 'OTP',
		permission: 'OTP',
		icon: <IconAdjustmentsCheck style={{ ...style }} />,
		children: [
			{
				name: 'Config OTP',
				permission: 'OTP:CONFIG_OTP',
				icon: <IconFileSettings style={{ ...style }} />,
				to: pathUrl.configphone,
			},
			{
				name: 'Report OTP',
				permission: 'OTP:REPORT_OTP',
				icon: <IconBrandIntercom style={{ ...style }} />,
				to: pathUrl.otpTracking,
			},
		],
	},
	{
		name: 'Develop',
		role: 'SUPERADMIN',
		icon: <IconDatabaseCog style={{ ...style }} />,
		children: [
			{
				name: 'Cache Config',
				role: 'SUPERADMIN',
				icon: <IconDatabaseCog style={{ ...style }} />,
				to: pathUrl.cacheConfig,
			},
			{
				name: 'Google API Stats',
				role: 'SUPERADMIN',
				icon: <IconBrandGoogleAnalytics style={{ ...style }} />,
				to: pathUrl.googleApiStats,
			},
			{
				name: 'Version Stats',
				role: 'SUPERADMIN',
				icon: <FaChartColumn style={{ ...style }} />,
				to: pathUrl.versionStats,
			},
			{
				name: 'Community Stats',
				role: 'SUPERADMIN',
				icon: <IconNetwork style={{ ...style }} />,
				to: pathUrl.communityStats,
			},
			{
				name: 'Block',
				role: 'SUPERADMIN',
				icon: <IconDatabaseCog style={{ ...style }} />,
				to: pathUrl.block,
			},
			{
				name: 'DB Top Storage',
				role: 'SUPERADMIN',
				icon: <IconDatabaseCog style={{ ...style }} />,
				to: pathUrl.databaseStorage,
			},
			{
				name: 'Script run',
				role: 'SUPERADMIN',
				icon: <IconPlayerPlay style={{ ...style }} />,
				to: pathUrl.scriptRun,
			},
		],
	},

	{
		name: 'Logout',
		icon: <IconOutbound style={{ ...style }} />,
		action: 'logout',
	},
	// {
	// 	name: 'Landing Page', // Tên của dropdown
	// 	icon: <IconLabel style={{ ...style }} />,
	// 	to: '/',
	// },
]
export default nav
